module.exports = __webpack_public_path__ + "img/flatbed-bottom.13e3e505.svg";